import React from 'react'
import LgyLink from 'app/components/util/lgy-link/LgyLink'

import externalLink from 'uswds/dist/img/external-link.svg'

export const MiniatureGear = (props) => {
  const quarterWide = (props.quarterWide) ? 'quarter-wide' : ''
  const quarterTall = (props.quarterTall) ? 'quarter-tall' : ''
  const halfWide = (props.halfWide) ? 'half-wide' : ''
  const halfTall = (props.halfTall) ? 'half-tall' : ''
  const doubleWide = (props.doubleWide) ? 'double-wide' : ''
  const doubleTall = (props.doubleTall) ? 'double-tall' : ''
  const tripleWide = (props.tripleWide) ? 'triple-wide' : ''
  const tripleTall = (props.tripleTall) ? 'triple-tall' : ''
  const quadrupleWide = (props.quadrupleWide) ? 'quadruple-wide' : ''
  const quadrupleTall = (props.quadrupleTall) ? 'quadruple-tall' : ''
  const quintupleWide = (props.quintupleWide) ? 'quintuple-wide' : ''
  const quintupleTall = (props.quintupleTall) ? 'quintuple-tall' : ''
  const fitHeight = (props.fitHeight) ? 'fit-height' : ''
  const width = quarterWide || halfWide || doubleWide || tripleWide || quadrupleWide || quintupleWide || ''
  const height = quarterTall || halfTall || doubleTall || tripleTall || quadrupleTall || quintupleTall || fitHeight || ''
  const openGearDescriptiveText = props.name ? `Open the ${props.name}` : 'Open the gear'
  return (
    <div className={`mini-gear ${width} ${height} ${props.className}`}>
      {props.link &&
        <LgyLink className='expand-gear-link' to={props.link} title={openGearDescriptiveText}>
          <img src={externalLink} alt={openGearDescriptiveText} />
        </LgyLink>}
      <div className='mini-gear-content-container'>{props.children}</div>
    </div>
  )
}

export default MiniatureGear
